export const listCopyDa = {
    published: "Publiceret",
    draft: "Kladde",
    name: "Navn",
    role: "Rolle",
    organisation: "Organisation",
    email: "E-mail",
    dateOfBirth: "Fødselsdato",
    labels: "Etiketter",
    status: "Status",
    actions: "Handlinger",
};
